import React from 'react';
import { OutlinedInput } from '@material-ui/core';

export default function InputTextField({errors, register, name, placeholder, required = true}) {
    return (
        <>
            <OutlinedInput
                fullWidth
                placeholder={placeholder}
                name={name}
                {...register(name, {
                    required: {
                        value: required,
                        message: 'Este campo es requerido',
                    },
                })}
            />
            {errors[`${name}`] && (
                <p className="text-red-700  text-xs error-text" style={{ marginTop: '0px' }}>
                    {errors[`${name}`].message}
                </p>
            )}
        </>
    )
}